import { useAnalyticsStore } from '@/store/analytics.store';
import '@/styles/analytics.css';

/** Briefcase icon */
function BriefcaseIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  );
}

/** Chart / bar-chart icon */
function ChartIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  );
}

/** File / document icon */
function FileIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  );
}

/** Send / paper-plane icon */
function SendIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  );
}

interface StatCardData {
  label: string;
  value: number;
  icon: React.ReactNode;
}

export function QuickStatsBar() {
  const overview = useAnalyticsStore((s) => s.overview);

  const stats: StatCardData[] = [
    {
      label: 'Jobs Tracked',
      value: overview.totalJobs,
      icon: <BriefcaseIcon />,
    },
    {
      label: 'Avg Match Score',
      value: overview.avgMatchScore,
      icon: <ChartIcon />,
    },
    {
      label: 'CVs Generated',
      value: overview.cvsGenerated,
      icon: <FileIcon />,
    },
    {
      label: 'Applications Sent',
      value: overview.applicationsSent,
      icon: <SendIcon />,
    },
  ];

  return (
    <div className="quick-stats-bar">
      {stats.map((stat) => (
        <div key={stat.label} className="stat-card">
          <div className="stat-card__icon" aria-hidden="true">
            {stat.icon}
          </div>
          <p className="stat-card__value">{stat.value}</p>
          <p className="stat-card__label">{stat.label}</p>
        </div>
      ))}
    </div>
  );
}
